(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function() {
  const form = document.getElementById('CorejiCartForm');
  if (!form) return;

  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';
  const changeUrl = root + 'cart/change.js';

  let timer = null;
  let busy = false;

  function setBusy(state) {
    busy = state;
    form.classList.toggle('is-updating', state);
    form.querySelectorAll('[data-cart-page-minus],[data-cart-page-plus],[data-cart-page-qty]').forEach(function(el) {
      el.disabled = state;
    });
  }

  async function updateQuantity(input) {
    if (!input || busy) return;

    const lineKey = input.dataset.cartLineKey;
    const quantity = Math.max(0, parseInt(input.value || '0', 10) || 0);
    if (!lineKey) return;

    setBusy(true);

    try {
      const response = await fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      });

      const result = await response.json().catch(function() { return {}; });
      if (!response.ok) {
        throw new Error(result.description || result.message || 'Impossible de mettre à jour le panier.');
      }

      window.location.reload();
    } catch (error) {
      console.error('[CorejiCart] Quantity update failed:', error);
      setBusy(false);
      window.alert(error.message || 'Impossible de mettre à jour le panier.');
    }
  }

  function scheduleUpdate(input, delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function() {
      updateQuantity(input);
    }, delay);
  }

  form.addEventListener('click', function(event) {
    const button = event.target.closest('[data-cart-page-minus],[data-cart-page-plus]');
    if (!button || busy) return;

    event.preventDefault();

    const wrapper = button.closest('.cj-cart-qty');
    const input = wrapper && wrapper.querySelector('[data-cart-page-qty]');
    if (!input) return;

    const current = Math.max(0, parseInt(input.value || '0', 10) || 0);
    input.value = button.matches('[data-cart-page-minus]')
      ? Math.max(0, current - 1)
      : current + 1;

    scheduleUpdate(input, 180);
  });

  form.addEventListener('change', function(event) {
    const input = event.target.closest('[data-cart-page-qty]');
    if (!input || busy) return;

    input.value = Math.max(0, parseInt(input.value || '0', 10) || 0);
    scheduleUpdate(input, 120);
  });

  form.addEventListener('input', function(event) {
    const input = event.target.closest('[data-cart-page-qty]');
    if (!input || busy) return;

    window.clearTimeout(timer);
    timer = window.setTimeout(function() {
      input.value = Math.max(0, parseInt(input.value || '0', 10) || 0);
      updateQuantity(input);
    }, 700);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-coreji-recommendations]').forEach((section) => {
  if (section.dataset.loaded === 'true') return;
  const observer = new IntersectionObserver((entries) => {
    if (!entries[0].isIntersecting) return;
    observer.disconnect();
    fetch(section.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const replacement = html.querySelector('[data-coreji-recommendations]');
        if (!replacement) return;
        replacement.dataset.loaded = 'true';
        section.replaceWith(replacement);
      });
  }, {rootMargin: '0px 0px 240px 0px'});
  observer.observe(section);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('change', function(event) {
  if (event.target.matches('[data-cj-offer]')) {
    const section = event.target.closest('[data-coreji-product-section]');
    const quantity = section && section.querySelector('[data-cj-qty]');
    if (quantity) quantity.value = event.target.value === '2' ? '2' : '1';
    return;
  }

  if (!event.target.matches('[data-cj-option]')) return;
  const section = event.target.closest('[data-coreji-product-section]');
  if (!section) return;

  const currentOffer = section.querySelector('[data-cj-offer]:checked')?.value || '1';
  const optionValues = Array.from(section.querySelectorAll('[data-cj-option]:checked'))
    .map((input) => input.dataset.optionValueId)
    .filter(Boolean)
    .join(',');

  const url = new URL(section.dataset.productUrl, window.location.origin);
  url.searchParams.set('section_id', section.dataset.sectionId);
  url.searchParams.set('option_values', optionValues);

  fetch(url.toString())
    .then((response) => response.text())
    .then((text) => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const replacement = html.querySelector('#' + section.id);
      if (!replacement) return;

      const offer = replacement.querySelector('[data-cj-offer][value="' + currentOffer + '"]');
      const quantity = replacement.querySelector('[data-cj-qty]');
      if (offer) {
        offer.checked = true;
        if (quantity) quantity.value = currentOffer === '2' ? '2' : '1';
      }

      section.replaceWith(replacement);
      const variantInput = replacement.querySelector('[data-cj-variant-id]');
      if (variantInput) {
        const browserUrl = new URL(window.location.href);
        browserUrl.searchParams.set('variant', variantInput.value);
        browserUrl.searchParams.delete('option_values');
        window.history.replaceState({}, '', browserUrl);
      }
    });
});

  } catch(e) { console.error(e); }
})();
})();
